import { BASE_URI, OPEN_URI } from "./index";

//注：apiURL设置，这里的设置与asyncRouterMap中的名称需要保持一致，如这里配置的user(adminResource=true)与asyncRouterMap中的user相对应决定权限
export const apiConfig = {
  auth: {
    resource: false,
    api: {
      login: BASE_URI + "/oauth/login",
      captcha: BASE_URI + "/oauth/captcha",
      checkToken: BASE_URI + "/auth/checkToken",
      resource: BASE_URI + "/auth/resources",
      logout: BASE_URI + "/auth/logout",
      changePassword: BASE_URI + "/auth/changePass"
    },
    meta: {
      name: "查询字典表，通用",
      url: BASE_URI + "/metadata/findByGroupCode"
    }
  },
  other: {
    resource: false,
    api: {}
  },
  openApi: {
    resource: false,
    api: {
      resume: {
        name: "简历信息",
        url: OPEN_URI + "/queryResume"
      },
      queryCertificate: {
        name: "查询证书",
        url: OPEN_URI + "/queryCertificate"
      }
    }
  },
  document: {
    name: "文件资源",
    resource: false,
    api: {
      upload: {
        name: "上传文件",
        url: BASE_URI + "/document/upload"
      },
      download: {
        name: "下载文件",
        url: BASE_URI + "/document/serve/"
      }
    }
  },
  userInfo: {
    name: "用户个人信息",
    resource: true,
    api: {
      getAllMapListMetaData: {
        name: "用户字典",
        url: BASE_URI + "/userInfo/getAllMapListMetaData"
      },
      sendMessage: {
        name: "发送信息",
        url: BASE_URI + "/userInfo/sendMessage"
      },
      sendMessagePreview: {
        name: "发送信息预览",
        url: BASE_URI + "/userInfo/sendMessagePreview"
      },
      pager: {
        name: "用户信息分页列表",
        url: BASE_URI + "/userInfo/pager"
      },
      searchPager: {
        name: "用户信息分页列表搜索功能",
        url: BASE_URI + "/userInfo/searchPager"
      },
      getUserList: {
        name: "用户列表",
        url: BASE_URI + "/userInfo/getUserList"
      },
      find: {
        name: "查询用户信息",
        url: BASE_URI + "/userInfo/find"
      },
      add: {
        name: "新增用户信息",
        url: BASE_URI + "/userInfo/add"
      },
      update: {
        name: "更新用户信息",
        url: BASE_URI + "/userInfo/update"
      },
      delete: {
        name: "删除用户",
        url: BASE_URI + "/userInfo/delete"
      },
      audit: {
        name: "审核用户信息",
        url: BASE_URI + "/userInfo/audit"
      },
      importIdPhoto: {
        name: "导入证件照",
        url: {
          import: BASE_URI + "/userInfo/importIdPhoto",
          exportError: BASE_URI + "/userInfo/exportIdPhotoError"
        }
      },
      importUserInfo: {
        name: "导入用户信息",
        url: {
          import: BASE_URI + "/userInfo/importUserInfo",
          exportError: BASE_URI + "/userInfo/exportUserInfoError"
        }
      },
      exportUserList: {
        name: "导出个人信息",
        url: BASE_URI + "/userInfo/export"
      },
      exportIdPhoto: {
        name: "导出证件照",
        url: BASE_URI + "/userInfo/exportIdPhoto"
      },
      mergeAccount: {
        name: "合并账户",
        url: BASE_URI + "/userInfo/mergeAccount"
      },
      userAnalyse: {
        name: "用户属性分析",
        url: BASE_URI + "/userInfo/userAnalyse"
      },
      userCountAnalyse: {
        name: "用户数量分析",
        url: BASE_URI + "/userInfo/userCountAnalyse"
      },
      userGrowAnalyse: {
        name: "新增用户数量分析",
        url: BASE_URI + "/userInfo/userGrowAnalyse"
      },
      userCerAnalyse: {
        name: "1类证书用户属性分析",
        url: BASE_URI + "/userInfo/userCerAnalyse"
      },
      userCerCountAnalyse: {
        name: "证书用户数量分析",
        url: BASE_URI + "/userInfo/userCerCountAnalyse"
      },
      userCerGrowAnalyse: {
        name: "新增证书用户数量分析",
        url: BASE_URI + "/userInfo/userCerGrowAnalyse"
      },
      userPaperCerAnalyse: {
        name: "2类证书用户属性分析",
        url: BASE_URI + "/userInfo/userPaperCerAnalyse"
      },
      userPaperCerCountAnalyse: {
        name: "证书用户数量分析",
        url: BASE_URI + "/userInfo/userPaperCerCountAnalyse"
      },
      userPaperCerGrowAnalyse: {
        name: "新增证书用户数量分析",
        url: BASE_URI + "/userInfo/userPaperCerGrowAnalyse"
      },
      bindUserProject: {
        name: "绑定用户项目",
        url: BASE_URI + "/userInfo/bindUserProject"
      }
    }
  },
  userResumeInfo: {
    name: "用户简历基本信息",
    resource: false,
    api: {
      getResumeHonourList: {
        name: "获取荣誉列表",
        url: BASE_URI + "/userResume/getResumeHonourList"
      },
      findResumeHonour: {
        name: "获取荣誉",
        url: BASE_URI + "/userResume/findResumeHonour"
      },
      addResumeHonour: {
        name: "新增荣誉",
        url: BASE_URI + "/userResume/addResumeHonour"
      },
      updateResumeHonour: {
        name: "更新荣誉",
        url: BASE_URI + "/userResume/updateResumeHonour"
      },
      deleteResumeHonour: {
        name: "删除荣誉",
        url: BASE_URI + "/userResume/deleteResumeHonour"
      },
      getResumeCertificateList: {
        name: "获取证书列表",
        url: BASE_URI + "/userResume/getResumeCertificateList"
      },
      findResumeCertificate: {
        name: "获取证书",
        url: BASE_URI + "/userResume/findResumeCertificate"
      },
      addResumeCertificate: {
        name: "新增证书",
        url: BASE_URI + "/userResume/addResumeCertificate"
      },
      updateResumeCertificate: {
        name: "更新证书",
        url: BASE_URI + "/userResume/updateResumeCertificate"
      },
      deleteResumeCertificate: {
        name: "删除证书",
        url: BASE_URI + "/userResume/deleteResumeCertificate"
      },
      getResumeEducationList: {
        name: "获取教育经历列表",
        url: BASE_URI + "/userResume/getResumeEducationList"
      },
      findResumeEducation: {
        name: "获取教育经历证书",
        url: BASE_URI + "/userResume/findResumeEducation"
      },
      addResumeEducation: {
        name: "新增教育经历证书",
        url: BASE_URI + "/userResume/addResumeEducation"
      },
      updateResumeEducation: {
        name: "更新教育经历证书",
        url: BASE_URI + "/userResume/updateResumeEducation"
      },
      deleteResumeEducation: {
        name: "删除教育经历证书",
        url: BASE_URI + "/userResume/deleteResumeEducation"
      },
      getResumeInternshipList: {
        name: "获取实习经历列表",
        url: BASE_URI + "/userResume/getResumeInternshipList"
      },
      findResumeInternship: {
        name: "获取实习经历",
        url: BASE_URI + "/userResume/findResumeInternship"
      },
      addResumeInternship: {
        name: "新增实习经历",
        url: BASE_URI + "/userResume/addResumeInternship"
      },
      updateResumeInternship: {
        name: "更新实习经历",
        url: BASE_URI + "/userResume/updateResumeInternship"
      },
      deleteResumeInternship: {
        name: "删除实习经历",
        url: BASE_URI + "/userResume/deleteResumeInternship"
      },
      getResumeProjectList: {
        name: "获取项目经历列表",
        url: BASE_URI + "/userResume/getResumeProjectList"
      },
      findResumeProject: {
        name: "获取项目经历",
        url: BASE_URI + "/userResume/findResumeProject"
      },
      addResumeProject: {
        name: "新增项目经历",
        url: BASE_URI + "/userResume/addResumeProject"
      },
      updateResumeProject: {
        name: "更新项目经历",
        url: BASE_URI + "/userResume/updateResumeProject"
      },
      deleteResumeProject: {
        name: "删除项目经历",
        url: BASE_URI + "/userResume/deleteResumeProject"
      },
      getResumeTrainingList: {
        name: "获取培训经历列表",
        url: BASE_URI + "/userResume/getResumeTrainingList"
      },
      findResumeTraining: {
        name: "获取培训经历",
        url: BASE_URI + "/userResume/findResumeTraining"
      },
      addResumeTraining: {
        name: "新增培训经历",
        url: BASE_URI + "/userResume/addResumeTraining"
      },
      updateResumeTraining: {
        name: "更新培训经历",
        url: BASE_URI + "/userResume/updateResumeTraining"
      },
      deleteResumeTraining: {
        name: "删除培训经历",
        url: BASE_URI + "/userResume/deleteResumeTraining"
      },
      getResumeWorkList: {
        name: "获取工作经历列表",
        url: BASE_URI + "/userResume/getResumeWorkList"
      },
      findResumeWork: {
        name: "获取工作经历",
        url: BASE_URI + "/userResume/findResumeWork"
      },
      addResumeWork: {
        name: "新增工作经历",
        url: BASE_URI + "/userResume/addResumeWork"
      },
      updateResumeWork: {
        name: "更新工作经历",
        url: BASE_URI + "/userResume/updateResumeWork"
      },
      deleteResumeWork: {
        name: "删除工作经历",
        url: BASE_URI + "/userResume/deleteResumeWork"
      }
    }
  },
  userAssess: {
    name: "用户测评信息",
    resource: true,
    api: {
      pager: {
        name: "用户测评信息分页列表",
        url: BASE_URI + "/userAssess/pager"
      },
      searchPager: {
        name: "用户测评信息分页列表搜索功能",
        url: BASE_URI + "/userAssess/searchPager"
      },
      getScaleList: {
        name: "查看测评详情",
        url: BASE_URI + "/userAssess/getScaleListByProId"
      },
      viewReport: {
        name: "查看测评报告",
        url: BASE_URI + "/oauth/getUserReport"
      },
      downloadReport: {
        name: "下载测评报告",
        url: BASE_URI + "/oauth/downloadReport"
      },
      downloadReportBatch: {
        name: "批量下载测评报告",
        url: BASE_URI + "/userAssess/downloadReportBatch"
      }
    }
  },
  userCertificate: {
    name: "用户证书信息",
    resource: true,
    api: {
      pager: {
        name: "用户证书信息分页列表",
        url: BASE_URI + "/userCertificate/pager"
      },
      searchPager: {
        name: "用户证书信息分页列表搜索功能",
        url: BASE_URI + "/userCertificate/searchPager"
      },
      viewCertificateImg: {
        name: "查看证书",
        url: BASE_URI + "/userCertificate/viewCertificateImg"
      },
      getDigitalCertificateList: {
        name: "查看电子证书信息",
        url: BASE_URI + "/userCertificate/getDigitalCertificateList"
      },
      getPaperCertificateInfo: {
        name: "查看纸质证书信息",
        url: BASE_URI + "/userCertificate/getPaperCertificateInfo"
      },
      editPaperCertificateStatus: {
        name: "标记纸质证书购买状态",
        url: BASE_URI + "/userCertificate/editPaperCertificateStatus"
      },
      editPaperCertificateStatusBatch: {
        name: "批量标记纸质证书购买状态",
        url: BASE_URI + "/userCertificate/editPaperCertificateStatusBatch"
      },
      uploadPaperCertificateUser: {
        name: "上传购买纸质证书用户",
        url: BASE_URI + "/userCertificate/uploadPaperCertificateUser"
      },
      exportUserCertificate: {
        name: "导出入库信息",
        url: BASE_URI + "/userCertificate/export"
      },
      exportZip: {
        name: "导出证书zip",
        url: BASE_URI + "/userCertificate/exportZip"
      },
      delete: {
        name: "删除证书",
        url: BASE_URI + "/userCertificate/delete"
      },
      add: {
        name: "添加证书",
        url: BASE_URI + "/userCertificate/add"
      },
      update: {
        name: "更新证书",
        url: BASE_URI + "/userCertificate/update"
      },
      find: {
        name: "查找证书",
        url: BASE_URI + "/userCertificate/find"
      },
      importUserCertificate: {
        name: "导入证书",
        url: {
          import: BASE_URI + "/userCertificate/importCertificate",
          exportError: BASE_URI + "/userCertificate/exportCertificateError"
        }
      },
      getCertificateCode: {
        name: "获取可用证书编号",
        url: BASE_URI + "/userCertificate/getCertificateCode"
      }
    }
  },
  addAgent: {
    name: "创建代理商",
    resource: true,
    api: {
      add: {
        name: "创建代理商",
        url: BASE_URI + "/agentInfo/add"
      }
    }
  },
  agentInfo: {
    name: "代理商列表",
    resource: true,
    api: {
      pager: {
        name: "代理商分页列表",
        url: BASE_URI + "/agentInfo/pager"
      },
      searchPager: {
        name: "代理商分页列表搜索功能",
        url: BASE_URI + "/agentInfo/searchPager"
      },
      find: {
        name: "查看代理商基本信息",
        url: BASE_URI + "/agentInfo/find"
      },
      getAgentByName: {
        name: "根据代理商名称模糊查询代理商列表",
        url: BASE_URI + "/agentInfo/getAgentByNameLike"
      },
      edit: {
        name: "编辑代理商基本信息",
        url: BASE_URI + "/agentInfo/edit"
      },
      getProjectList: {
        name: "代理商项目列表",
        url: BASE_URI + "/agentInfo/getProjectList"
      },
      getProjectUserPager: {
        name: "查看参与项目的用户",
        url: BASE_URI + "/agentInfo/getProjectUserPager"
      },
      getSubAgentList: {
        name: "子代理商列表",
        url: BASE_URI + "/agentInfo/getSubAgentList"
      },
      getSubAgentProjectList: {
        name: "子代理商项目列表",
        url: BASE_URI + "/agentInfo/getSubAgentProjectList"
      },
      getSubAgentProjectUserPager: {
        name: "查看子代理商项目的用户",
        url: BASE_URI + "/agentInfo/getSubAgentProjectUserPager"
      },
      suspend: {
        name: "暂停账号",
        url: BASE_URI + "/agentInfo/suspend"
      },
      delete: {
        name: "删除代理商",
        url: BASE_URI + "/agentInfo/delete"
      },
      agentList: {
        name: "代理商列表",
        url: BASE_URI + "/agentInfo/getAgentList"
      },
      getParentAgentList: {
        name: "查询可绑定的父代理商列表",
        url: BASE_URI + "/agentInfo/getParentAgentList"
      }
    }
  },
  addProject: {
    name: "创建项目",
    resource: true,
    api: {
      add: {
        name: "创建项目",
        url: BASE_URI + "/projectInfo/add"
      }
    }
  },
  certificate: {
    name: "证书级别",
    resource: true,
    api: {
      pager: {
        name: "证书级别分页列表",
        url: BASE_URI + "/certificate/pager"
      },
      edit: {
        name: "编辑证书级别",
        url: BASE_URI + "/certificate/edit"
      },
      delete: {
        name: "删除证书级别",
        url: BASE_URI + "/certificate/delete"
      }
    }
  },
  projectInfo: {
    name: "项目列表",
    resource: true,
    api: {
      pager: {
        name: "项目分页列表",
        url: BASE_URI + "/projectInfo/pager"
      },
      searchPager: {
        name: "项目分页列表搜索功能",
        url: BASE_URI + "/projectInfo/searchPager"
      },
      projectList: {
        name: "项目列表",
        url: BASE_URI + "/projectInfo/list"
      },
      listByAgent: {
        name: "代理商项目列表",
        url: BASE_URI + "/projectInfo/listByAgent"
      },
      find: {
        name: "查看项目详情",
        url: BASE_URI + "/projectInfo/find"
      },
      edit: {
        name: "编辑项目",
        url: BASE_URI + "/projectInfo/edit"
      },
      findProjectAgentPager: {
        name: "查看项目代理商分页",
        url: BASE_URI + "/projectInfo/getProjectAgentPager"
      },
      authorizeAgent: {
        name: "授权代理商",
        url: {
          agentList: BASE_URI + "/projectInfo/authorizeAgent",
          authorize: BASE_URI + "/projectInfo/authorize"
        }
      },
      suspend: {
        name: "暂停项目",
        url: BASE_URI + "/projectInfo/suspend"
      },
      open: {
        name: "开放项目",
        url: BASE_URI + "/projectInfo/open"
      },
      delete: {
        name: "删除项目",
        url: BASE_URI + "/projectInfo/delete"
      },
      getProjectUser: {
        name: "查询项目用户",
        url: BASE_URI + "/projectInfo/getProjectUser"
      },
      certificateTemplate: {
        name: "查询证书模板",
        url: BASE_URI + "/certificateTemplate/list"
      }
    }
  },
  projectStatistics: {
    name: "项目统计",
    resource: true,
    api: {
      profile: {
        name: "项目概况",
        url: BASE_URI + "/projectStatistics/profile"
      },
      detail: {
        name: "项目详细统计",
        url: {
          pager: BASE_URI + "/projectStatistics/detailPager",
          searchPager: BASE_URI + "/projectStatistics/detailSearchPager",
          projectUserPager: BASE_URI + "/projectStatistics/projectUserPager"
        }
      },
      projectUserSex: {
        name: "项目用户性别",
        url: BASE_URI + "/projectStatistics/projectUserSex"
      },
      projectUserLevel: {
        name: "项目用户性别",
        url: BASE_URI + "/projectStatistics/projectUserLevel"
      }
    }
  },
  importUserAccount: {
    name: "导入生成测评账号",
    resource: true,
    api: {
      userPager: {
        name: "测评账号分页列表",
        url: {
          pager: BASE_URI + "/userAccount/userPager",
          searchPager: BASE_URI + "/userAccount/searchUserPager"
        }
      },
      produce: {
        name: "生成测评账号",
        url: {
          downloadUserAccountTemplate:
            BASE_URI + "/importUserAccount/downloadUserAccountTemplate",
          uploadUserInfo: BASE_URI + "/importUserAccount/uploadUserInfo",
          getProjectList: BASE_URI + "/importUserAccount/getProjectList",
          accountImport: BASE_URI + "/userAccount/accountImport",
          produceUserAccount: BASE_URI + "/userAccount/createAccount",
          exportUserAccount: BASE_URI + "/userAccount/exportAccount",
          exportAccountError: BASE_URI + "/userAccount/exportAccountError"
        }
      }
    }
  },
  addScale: {
    name: "创建量表",
    resource: true,
    api: {
      add: {
        name: "创建量表",
        url: {
          add: BASE_URI + "/scaleInfo/add",
          uploadScale: BASE_URI + "/scaleInfo/uploadScale",
          downloadReportRuleTemplate:
            BASE_URI + "/scaleInfo/downloadReportRule",
          uploadloadReportRule: BASE_URI + "/scaleInfo/uploadloadReportRule"
        }
      }
    }
  },
  scaleInfo: {
    name: "量表列表",
    resource: true,
    api: {
      pager: {
        name: "量表分页列表",
        url: BASE_URI + "/scaleInfo/pager"
      },
      searchPager: {
        name: "量表分页列表搜索功能",
        url: BASE_URI + "/scaleInfo/searchPager"
      },
      add: {
        name: "创建量表",
        url: BASE_URI + "/scaleInfo/add"
      },
      find: {
        name: "查看量表基本信息",
        url: BASE_URI + "/scaleInfo/find"
      },
      edit: {
        name: "编辑量表",
        url: BASE_URI + "/scaleInfo/edit"
      },
      getProjectList: {
        name: "查看关联的项目",
        url: BASE_URI + "/scaleInfo/getProjectList"
      },
      delete: {
        name: "删除量表",
        url: BASE_URI + "/scaleInfo/delete"
      },
      export: {
        name: "导出量表",
        url: BASE_URI + "/scaleInfo/export"
      },
      exportBatch: {
        name: "批量导出量表",
        url: BASE_URI + "/scaleInfo/exportBatch"
      },
      getScaleByName: {
        name: "根据量表名称模糊查询量表列表",
        url: BASE_URI + "/scaleInfo/getScaleListByNameLike"
      },
      scaleList: {
        name: "量表列表",
        url: BASE_URI + "/scaleInfo/getScaleList"
      },
      getScaleProjectName: {
        name: "量表被调用项目名称",
        url: BASE_URI + "/scaleInfo/getScaleProjectName"
      },
      getScaleUserInfo: {
        name: "量表用户测评信息",
        url: BASE_URI + "/scaleInfo/getScaleUserInfo"
      },
      subjectPager: {
        name: "量表用户测评信息",
        url: BASE_URI + "/scaleInfo/subjectPager"
      },
      findSubject: {
        name: "量表用户测评信息",
        url: BASE_URI + "/scaleInfo/findSubject"
      },
      saveSubject: {
        name: "量表用户测评信息",
        url: BASE_URI + "/scaleInfo/saveSubject"
      },
      delSubject: {
        name: "量表用户测评信息",
        url: BASE_URI + "/scaleInfo/delSubject"
      },
      batchDeleteSubject: {
        name: "量表用户测评信息",
        url: BASE_URI + "/scaleInfo/batchDeleteSubject"
      },
      getWdList: {
        name: "维度列表",
        url: BASE_URI + "/scaleInfo/getWdList"
      },
      getWdInfo: {
        name: "维度信息",
        url: BASE_URI + "/scaleInfo/getWdInfo"
      },
      saveWdInfo: {
        name: "维度信息",
        url: BASE_URI + "/scaleInfo/saveWdInfo"
      },
      delWd: {
        name: "维度信息",
        url: BASE_URI + "/scaleInfo/delWd"
      },
      getSubByWdcode: {
        name: "维度信息",
        url: BASE_URI + "/scaleInfo/getSubByWdcode"
      },
      getScaleProject: {
        name: "维度信息",
        url: BASE_URI + "/scaleInfo/getScaleProject"
      },
      importSubjects: {
        name: "导入量表题目",
        url: {
          import: BASE_URI + "/scaleInfo/importSubjects",
          exportError: BASE_URI + "/scaleInfo/exportSubjectsError"
        }
      }
    }
  },
  orderInfo: {
    name: "订单列表",
    resource: true,
    api: {
      pager: {
        name: "订单分页列表",
        url: BASE_URI + "/orderInfo/pager"
      },
      searchPager: {
        name: "订单分页列表搜索功能",
        url: BASE_URI + "/orderInfo/searchPager"
      },
      find: {
        name: "查看订单详情",
        url: BASE_URI + "/orderInfo/find"
      },
      audit: {
        name: "审核订单",
        url: BASE_URI + "/orderInfo/audit"
      }
    }
  },
  logInfo: {
    name: "操作日志",
    resource: true,
    api: {
      pager: {
        name: "操作日志分页列表",
        url: BASE_URI + "/logInfo/pager"
      },
      searchPager: {
        name: "操作日志分页列表搜索功能",
        url: BASE_URI + "/logInfo/searchPager"
      }
    }
  },
  agentUser: {
    name: "权限管理",
    resource: true,
    api: {
      pager: {
        name: "代理商用户分页列表",
        url: BASE_URI + "/agentUser/pager"
      },
      searchPager: {
        name: "代理商用户分页列表搜索功能",
        url: BASE_URI + "/agentUser/searchPager"
      },
      add: {
        name: "新增代理商用户",
        url: BASE_URI + "/agentUser/add"
      },
      viewPassword: {
        name: "查看初始密码",
        url: BASE_URI + "/agentUser/viewPassword"
      },
      resetPassword: {
        name: "重置密码",
        url: BASE_URI + "/agentUser/resetPassword"
      },
      upresource: {
        name: "授权资源",
        url: {
          auth: BASE_URI + "/agentUser/upresource",
          tree: BASE_URI + "/agentResource/tree",
          rel: BASE_URI + "/agentUser/resources"
        }
      },
      dataPermission: {
        name: "授权数据",
        url: {
          list: BASE_URI + "/agentUser/dataPermissionList",
          update: BASE_URI + "/agentUser/updateDataPermission"
        }
      },
      delete: {
        name: "删除代理商用户",
        url: BASE_URI + "/agentUser/delete"
      }
    }
  },
  agentResource: {
    name: "代理商资源管理",
    resource: true,
    api: {
      search: {
        name: "查询代理商资源",
        url: BASE_URI + "/agentResource/tree"
      },
      delete: {
        name: "删除代理商资源",
        url: BASE_URI + "/agentResource/delete"
      },
      update: {
        name: "更新代理商资源",
        url: BASE_URI + "/agentResource/modify"
      },
      add: {
        name: "新增代理商资源",
        url: BASE_URI + "/adminResource/add"
      }
    }
  },
  agentStatistics: {
    name: "代理商统计",
    api: {
      getAgentCount: {
        name: "代理商新增数量",
        url: BASE_URI + "/agentStatistics/getAgentCount"
      },
      getAgentUserSex: {
        name: "代理商引流用户性别",
        url: BASE_URI + "/agentStatistics/getAgentUserSex"
      },
      getAgentUserLevel: {
        name: "代理商引流用户等级",
        url: BASE_URI + "/agentStatistics/getAgentUserLevel"
      },
      getAgentProjectUserCount: {
        name: "代理商项目用户数量",
        url: BASE_URI + "/agentStatistics/getAgentProjectUserCount"
      }
    }
  },
  cityCode: {
    name: "城市管理",
    resource: true,
    api: {
      getAllProvince: {
        name: "查询省份列表",
        url: BASE_URI + "/cityCode/getAllProvince"
      },
      getAllCity: {
        name: "查询城市列表",
        url: BASE_URI + "/cityCode/getAllCity"
      },
      getCityByProvince: {
        name: "根据省份code查询城市列表",
        url: BASE_URI + "/cityCode/getCityByProvince"
      },
      getAreaListByCity: {
        name: "根据省份code查询城市列表",
        url: BASE_URI + "/cityCode/getAreaListByCity"
      },
      getCityByAreaCode: {
        name: "根据省份code查询城市",
        url: BASE_URI + "/cityCode/getCityByAreaCode"
      }
    }
  },
  statistics: {
    name: "统计",
    resource: true,
    api: {
      user: {
        name: "",
        url: BASE_URI + "/statistics/user"
      },
      statistics: {
        name: "",
        url: BASE_URI + "/statistics/statistics"
      },
      hasCertificateUser: {
        name: "",
        url: BASE_URI + "/statistics/hasCertificateUser"
      }
    }
  },
  adminUserInfo: {
    name: "管理员管理",
    resource: true,
    api: {
      pager: {
        name: "管理员分页列表",
        url: BASE_URI + "/adminUserInfo/pager"
      },
      searchPager: {
        name: "管理员分页列表搜索功能",
        url: BASE_URI + "/adminUserInfo/searchPager"
      },

      add: {
        name: "新增管理员",
        url: BASE_URI + "/adminUserInfo/add"
      },
      update: {
        name: "更新管理员",
        url: BASE_URI + "/adminUserInfo/modify"
      },
      delete: {
        name: "删除管理员",
        url: BASE_URI + "/adminUserInfo/delete"
      },
      resetpwd: {
        name: "重置密码",
        url: BASE_URI + "/adminUserInfo/resetpwd"
      },
      uproles: {
        name: "分配管理员角色",
        url: {
          rel: BASE_URI + "/adminUserInfo/roles",
          list: BASE_URI + "/adminRole/list",
          auth: BASE_URI + "/adminUserInfo/uprole"
        }
      }
    }
  },
  adminRole: {
    name: "管理员角色管理",
    resource: true,
    api: {
      search: {
        name: "查询管理员角色",
        url: BASE_URI + "/adminRole/list"
      },
      delete: {
        name: "删除管理员角色",
        url: BASE_URI + "/adminRole/delete"
      },
      update: {
        name: "更新管理员角色",
        url: BASE_URI + "/adminRole/modify"
      },
      add: {
        name: "新增管理员角色",
        url: BASE_URI + "/adminRole/add"
      },
      upresource: {
        name: "管理员角色授权",
        url: {
          auth: BASE_URI + "/adminRole/upresource",
          tree: BASE_URI + "/adminResource/tree",
          rel: BASE_URI + "/adminRole/resources"
        }
      }
    }
  },
  adminResource: {
    name: "管理员资源管理",
    resource: true,
    api: {
      search: {
        name: "查询管理员资源",
        url: BASE_URI + "/adminResource/tree"
      },
      delete: {
        name: "删除管理员资源",
        url: BASE_URI + "/adminResource/delete"
      },
      update: {
        name: "更新管理员资源",
        url: BASE_URI + "/adminResource/modify"
      },
      add: {
        name: "新增管理员资源",
        url: BASE_URI + "/adminResource/add"
      }
    }
  }
};

/**
 * 获取资源树配置，用于权限管理
 */
export function getResourceConfigs() {
  let result = [];

  Object.keys(apiConfig).forEach(function(key) {
    let itemVal = apiConfig[key];
    if (itemVal && itemVal.resource == true) {
      let res = { operatorCode: key, operatorName: itemVal.name };
      let operators = [];
      if (itemVal.api && Object.keys(itemVal.api).length > 0) {
        Object.keys(itemVal.api).forEach(function(opKey) {
          let operMap = itemVal.api[opKey];
          if (operMap) {
            var authUrls = getAuthUrls(operMap.url);
            let operator = {
              operatorCode: opKey,
              operatorName: operMap.name,
              authUrls: authUrls
            };
            operators.push(operator);
          }
        });
      }
      res.operators = operators;
      result.push(res);
    }
  });

  return result;
}

function getAuthUrls(url) {
  if (url && typeof url == "string") {
    return [url];
  } else if (url && Object.keys(url).length > 0) {
    let urls = [];
    Object.keys(url).forEach(function(key) {
      var val = url[key];
      if (val) {
        urls.push(val);
      }
    });
    return urls;
  }
  return null;
}
